(function () {
  var API_KEY = '893afffe28e0e2578e3d50366dc78762';
  var SESSION_REPLAY_RATE = 0.02;
  var sdkLoading = false;
  var sdkReady = false;

  function getUserEmail() {
    var u = window.__PCL_USER__;
    if (u && u.email) return u.email;
    var p = window.__AP_PREFS__;
    if (p && p.email) return p.email;
    return null;
  }

  function isLoggedIn() {
    if (getUserEmail()) return true;
    var p = window.__AP_PREFS__;
    if (p && p.customerId) return true;
    var u = window.__PCL_USER__;
    if (u && u.id) return true;
    if (window.ShopifyAnalytics && ShopifyAnalytics.meta && ShopifyAnalytics.meta.page) {
      return !!ShopifyAnalytics.meta.page.customerId;
    }
    return false;
  }

  function getConsentState() {
    if (navigator.globalPrivacyControl) return 'block';

    var cp = window.Shopify && Shopify.customerPrivacy;
    if (!cp || typeof cp.currentVisitorConsent !== 'function') return null;

    var c = cp.currentVisitorConsent();

    if (c.marketing === 'no') return 'block';

    if (c.marketing === 'yes') {
      if (c.sale_of_data === 'no' || c.saleOfData === 'no') return 'limit';
      return 'allow';
    }

    // marketing is empty — consent not yet collected
    // Logged-in users accepted ToS which covers analytics consent
    if (isLoggedIn()) {
      if (typeof cp.setTrackingConsent === 'function') {
        cp.setTrackingConsent(
          { marketing: true, analytics: true, preferences: true, sale_of_data: true },
          function () {}
        );
      }
      return 'allow';
    }

    return 'block';
  }

  function loadAndInit(state) {
    if (sdkLoading) return;
    sdkLoading = true;

    var script = document.createElement('script');
    script.src = 'https://cdn.amplitude.com/script/' + API_KEY + '.js';
    script.onload = function () {
      if (!window.amplitude) return;

      if (state === 'allow' && window.sessionReplay) {
        window.amplitude.add(window.sessionReplay.plugin({ sampleRate: SESSION_REPLAY_RATE }));
      }

      window.amplitude.init(API_KEY, {
        autocapture: true,
        fetchRemoteConfig: true,
      });

      var email = getUserEmail();
      if (email) window.amplitude.setUserId(email);

      sdkReady = true;
      trackShopifyEvents();
    };
    document.head.appendChild(script);
  }

  function handleConsent(state) {
    if (state === 'block') return;

    if (!sdkReady) {
      loadAndInit(state);
    } else {
      // Consent changed after SDK was already loaded
      window.amplitude.setOptOut(state === 'block');
    }
  }

  // Poll for consent API — never fall back to 'allow', just wait
  var attempts = 0;
  var poll = setInterval(function () {
    attempts++;
    var state = getConsentState();

    if (state !== null) {
      clearInterval(poll);
      handleConsent(state);
      return;
    }

    if (attempts >= 100) clearInterval(poll);
  }, 100);

  // ── Shopify e-commerce events ────────────────────────────────────────────────

  function trackShopifyEvents() {
    if (!window.amplitude) return;

    var meta = window.ShopifyAnalytics && ShopifyAnalytics.meta;
    var page = meta && meta.page;

    // Product Viewed
    if (page && page.resourceType === 'product' && meta.product) {
      var p = meta.product;
      var v = p.variants && p.variants[0];
      amplitude.track('Product Viewed', {
        product_id: String(p.id),
        variant_id: v ? String(v.id) : undefined,
        product_title: v ? v.name : undefined,
        price: v ? v.price / 100 : undefined,
        vendor: p.vendor,
        product_type: p.type,
        currency: meta.currency,
      });
    }

    // Collection Viewed
    if (page && page.resourceType === 'collection') {
      amplitude.track('Collection Viewed', {
        collection_id: String(page.resourceId),
      });
    }

    // Search Submitted
    if (window.location.pathname === '/search') {
      var q = new URLSearchParams(window.location.search).get('q');
      if (q) amplitude.track('Search Submitted', { query: q });
    }

    // Cart Viewed
    if (window.location.pathname === '/cart') {
      amplitude.track('Cart Viewed');
    }

    // Order Completed (thank-you / order-status page)
    if (window.Shopify && Shopify.checkout) {
      var o = Shopify.checkout;
      var items = (o.line_items || []).map(function (li) {
        return {
          product_id: String(li.product_id),
          variant_id: String(li.variant_id),
          title: li.title,
          quantity: li.quantity,
          price: parseFloat(li.price),
        };
      });
      amplitude.track('Order Completed', {
        order_id: String(o.order_id),
        total: parseFloat(o.total_price),
        subtotal: parseFloat(o.subtotal_price),
        tax: parseFloat(o.total_tax),
        currency: o.currency,
        item_count: items.length,
        items: items,
      });
    }

    // Product Added to Cart — intercept fetch to /cart/add
    var origFetch = window.fetch;
    window.fetch = function (url, opts) {
      var result = origFetch.apply(this, arguments);
      try {
        var u = typeof url === 'string' ? url : (url && url.url) || '';
        if (/\/cart\/add/.test(u) && opts && /post/i.test(opts.method || '')) {
          result.then(function (res) {
            if (!res.ok) return;
            res.clone().json().then(function (data) {
              var list = data.items || (data.id ? [data] : []);
              list.forEach(function (item) {
                amplitude.track('Product Added to Cart', {
                  product_id: String(item.product_id),
                  variant_id: String(item.variant_id || item.id),
                  title: item.title,
                  quantity: item.quantity,
                  price: item.price / 100,
                });
              });
            }).catch(function () {});
          }).catch(function () {});
        }
      } catch (e) {}
      return result;
    };
  }

  // React to cookie banner interactions
  document.addEventListener('visitorConsentCollected', function () {
    var state = getConsentState();
    if (!state) return;

    if (sdkReady) {
      if (state === 'block') {
        window.amplitude.setOptOut(true);
      } else {
        window.amplitude.setOptOut(false);
      }
    } else {
      handleConsent(state);
    }
  });
})();
